import Vue from "vue";
import VueRouter from "vue-router";
import UserLayout from "../layouts/user-layout.vue";
import AuthLayout from "../layouts/auth-layout.vue";
import ProductLayout from "../layouts/product-layout.vue";
import RuleLayout from "../layouts/rule-layout.vue";
import ProductsListPage from "../pages/products/products-list.vue";
import Store from "../store";
import UsersListPage from "../pages/users/user-list.vue";
import RuleListPage from "../pages/rules/rule-list.vue";
import LoginPage from "../pages/auth/login.vue";
import LogoutPage from "../pages/auth/logout.vue";
import SalesInvoicesLayout from "../layouts/sales-invoices-layout.vue";
import SalesInvoicesView from "../pages/sales-invoices/sales-invoices-view";
import ResetPasswordPage from "../pages/auth/reset-password";
import RegistrationPage from "../pages/auth/registration";
import ActivationPage from "../pages/auth/activate";
import ShopsMapView from "../pages/shops-map/shops-map-view";
import ShopsAdminListPage from "../pages/shops-admin/shops-admin-list";
import ShopsMapLayout from "../layouts/shops-map-layout";
import ShopsAdminLayout from "../layouts/shops-admin-layout";
import IframeLayout from "../layouts/iframe-layout";
import IframePageView from "../pages/iframe-page/iframe-page-view";
import ExportSaleInvoiceLayout from "../layouts/export-sale-invoice-layout";
import ClientLayout from "../layouts/client-layout";
import ExportClientLayout from "../layouts/export-client-layout";
import ExportSaleInvoiceListPage from "../pages/export-sale-invoice/export-sale-invoice-list";
import ExportSaleInvoiceEditPage from "../pages/export-sale-invoice/export-sale-invoice-edit";
import ClientListPage from "../pages/clients/client-list";
import ExportClientListPage from "../pages/export-clients/client-list";
import ExportSaleInvoiceViewPage from "../pages/export-sale-invoice/export-sale-invoice-view";
import UnmatchedShopsLayout from "../layouts/unmatched-shops-layout";
import UnmatchedShopsList from "../pages/unmatched-shops/unmatched-shops-list";
import UserSettingsLayout from "../layouts/user-settings-layout";
import UserSettingsView from "../pages/user-settings/user-settings-view";
import LogsLayout from "../layouts/logs-layout";
import LogsList from "../pages/logs/logs-list";
import NotificationCenterLayout from "../layouts/notification-center-layout";
import NotificationCenterList from "../pages/notification-center/notification-center-list";
import WorkOrderView from "../pages/work-order/work-order-view";
import WorkOrderLayout from "../layouts/work-order-layout";
import WorkOrderList from "../pages/work-order/work-order-list.vue";
import WorkOrderLineNumberSelect from "../pages/work-order/work-order-line-number-select.vue";
import PermissionMixin from "../mixins/permissionMixin";
import ExtProductPriceLayout from "../layouts/ext-product-price-layout.vue";
import ExtProductPriceList from "../pages/ext-product-price/ext-product-price-list";
import ExtProductPriceView from "../pages/ext-product-price/ext-product-price-view";
import CampaignLayout from "@/layouts/campaign-layout.vue";
import CampaignList from "../pages/campaign/campaign-list";
import AnalysisLayout from "@/layouts/analysis-layout.vue";
import AnalysisView from "@/pages/analysis/analysis-view.vue";
import ShipmentLayout from "../layouts/shipment-layout.vue";
import ShipmentsList from "../pages/shipment/shipment-list.vue";
import ProductionAnalysisView from "@/pages/production-analysis/production-analysis-view.vue";
import ProductionAnalysisLayout from "@/layouts/production-analysis-layout.vue";
import PublicShipmentLayout from "../layouts/public-shipment-layout.vue";
import PublicShipmentView from "../pages/public/shipment/public-shipment-view.vue";
import ErrorView from "../pages/public/shipment/error-view.vue";
import TagLayout from "../layouts/tag-layout.vue";
import TagListPage from "../pages/tags/tag-list.vue";

Vue.use(VueRouter);
let routes = [
    {
        path: "/",
        name: "products-list",
        component: ProductLayout,
        redirect: { name: "product-list" },
        children: [
            {
                path: "/products",
                component: ProductsListPage,
                children: [
                    {
                        path: "",
                        name: "product-list",
                        component: ProductsListPage,
                        meta: {
                            title: "Products",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ProductStore/toggleDrawer", false);
                            Store.commit("ProductStore/setActiveProduct", {});
                            Store.commit("ProductStore/setRequestSuccess", false);
                            Store.commit("ProductStore/setRequestError", false);
                            Store.commit("ProductStore/setPriceModal", false);
                            next();
                        },
                    },
                    {
                        path: ":productId",
                        name: "product-view",
                        component: ProductsListPage,
                        meta: {
                            title: "Products",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ProductStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":productId/edit",
                        name: "product-edit",
                        component: ProductsListPage,
                        meta: {
                            title: "Products",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ProductStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/users",
        name: "users",
        component: UserLayout,
        children: [
            {
                path: "/users",
                component: UsersListPage,
                children: [
                    {
                        path: "",
                        name: "user-list",
                        component: UsersListPage,
                        meta: {
                            title: "Users",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("UserStore/toggleDrawer", false);
                            Store.commit("UserStore/setActiveUser", {});
                            next();
                        },
                    },
                ],
            },

            {
                path: ":userId",
                name: "user-view",
                component: UsersListPage,
                meta: {
                    title: "Users",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("UserStore/toggleDrawer", true);
                    next();
                },
            },
            {
                path: ":userId/edit",
                name: "user-edit",
                component: UsersListPage,
                meta: {
                    title: "Users",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("UserStore/toggleDrawer", true);
                    next();
                },
            },
        ],
    },
    {
        path: "/rules",
        name: "rules",
        component: RuleLayout,
        children: [
            {
                path: "/rules",
                component: RuleListPage,
                children: [
                    {
                        path: "",
                        name: "rule-list",
                        component: RuleListPage,
                        meta: {
                            title: "Rules",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("RuleStore/toggleDrawer", false);
                            Store.commit("RuleStore/setActiveRule", {});
                            next();
                        },
                    },
                ],
            },

            {
                path: ":ruleId",
                name: "rule-view",
                component: RuleListPage,
                meta: {
                    title: "Rules",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("RuleStore/toggleDrawer", true);
                    next();
                },
            },
            {
                path: ":ruleId/edit",
                name: "rule-edit",
                component: RuleListPage,
                meta: {
                    title: "Rules",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("RuleStore/toggleDrawer", true);
                    next();
                },
            },
        ],
    },
    {
        path: "/sales-invoices",
        name: "sales-invoices",
        component: SalesInvoicesLayout,
        redirect: { name: "sales-invoices" },
        children: [
            {
                path: "/sales-invoices",
                component: SalesInvoicesView,
                children: [
                    {
                        path: "",
                        name: "sales-invoices-view",
                        component: SalesInvoicesView,
                        meta: {
                            title: "Sales Invoices",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            //Store.commit("UserStore/toggleDrawer", false);
                            //Store.commit("UserStore/setActiveUser", {});
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/shops",
        name: "shops",
        component: ShopsMapLayout,
        redirect: { name: "shops" },
        children: [
            {
                path: "/shops",
                component: ShopsMapView,
                children: [
                    {
                        path: "",
                        name: "shops-map-view",
                        component: ShopsMapView,
                        meta: {
                            title: "Shops map",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            //Store.commit("UserStore/toggleDrawer", false);
                            //Store.commit("UserStore/setActiveUser", {});
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/shops-admin",
        name: "shops-admin-list",
        component: ShopsAdminLayout,
        redirect: { name: "shops-admin-list" },
        children: [
            {
                path: "/shops-admin",
                component: ShopsAdminListPage,
                children: [
                    {
                        path: "",
                        name: "shops-admin-list",
                        component: ShopsAdminListPage,
                        meta: {
                            title: "Shops",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ShopsAdminStore/toggleDrawer", false);
                            Store.commit("ShopsAdminStore/setActiveShop", {});
                            Store.commit("ShopsAdminStore/setRequestSuccess", false);
                            Store.commit("ShopsAdminStore/setRequestError", false);
                            next();
                        },
                    },
                    {
                        path: ":shopId",
                        name: "shops-admin-view",
                        component: ShopsAdminListPage,
                        meta: {
                            title: "Shops",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ShopsAdminStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":shopId/edit",
                        name: "shops-admin-edit",
                        component: ShopsAdminListPage,
                        meta: {
                            title: "Shops",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ShopsAdminStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: AuthLayout,
        children: [
            {
                path: "/login",
                component: LoginPage,
                children: [
                    {
                        path: "",
                        name: "login",
                        component: LoginPage,
                        meta: {
                            title: "Login",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/logout",
        name: "logout",
        component: AuthLayout,
        children: [
            {
                path: "/logout",
                component: LogoutPage,
                children: [
                    {
                        path: "",
                        name: "logout",
                        component: LogoutPage,
                        meta: {
                            title: "Logout",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/reset-password",
        name: "reset-password",
        component: AuthLayout,
        children: [
            {
                path: "/reset-password",
                component: ResetPasswordPage,
                children: [
                    {
                        path: "",
                        name: "reset-password",
                        component: ResetPasswordPage,
                        meta: {
                            title: "Reset password",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/unmatched-shops",
        name: "unmatched-shops",
        component: UnmatchedShopsLayout,
        redirect: { name: "unmatched-shops" },
        children: [
            {
                path: "/unmatched-shops",
                component: UnmatchedShopsList,
                children: [
                    {
                        path: "",
                        name: "unmatched-shops-list",
                        component: UnmatchedShopsList,
                        meta: {
                            title: "Unmatched shops",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("UnmatchedShopsStore/toggleDrawer", false);
                            Store.commit("UnmatchedShopsStore/setActiveUnmatchedShop", {});
                            next();
                        },
                    },
                    {
                        path: ":invoiceId/:invoiceType",
                        name: "unmatched-shops-view",
                        component: UnmatchedShopsList,
                        meta: {
                            title: "Unmatched shops",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("UnmatchedShopsStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    //
    {
        path: "/registration",
        name: "registration",
        component: AuthLayout,
        children: [
            {
                path: "/registration",
                component: RegistrationPage,
                children: [
                    {
                        path: "",
                        name: "registration",
                        component: RegistrationPage,
                        meta: {
                            title: "Registration",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/activate",
        name: "activate",
        component: AuthLayout,
        children: [
            {
                path: "/activate",
                component: ActivationPage,
                children: [
                    {
                        path: "",
                        name: "activate",
                        component: ActivationPage,
                        meta: {
                            title: "Activation",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/export-sale-invoice",
        name: "export-sale-invoice",
        component: ExportSaleInvoiceLayout,
        redirect: { name: "export-sale-invoice" },
        children: [
            {
                path: "/export-sale-invoice",
                component: ExportSaleInvoiceListPage,
                children: [
                    {
                        path: "",
                        name: "export-sale-invoice-list",
                        component: ExportSaleInvoiceListPage,
                        meta: {
                            title: "Export sales invoices",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportSaleInvoiceStore/resetActiveExportInvoice");
                            next();
                        },
                    },
                    {
                        path: ":exportInvoiceId",
                        name: "export-sale-invoice-view",
                        component: ExportSaleInvoiceViewPage,
                        meta: {
                            title: "Export sales invoices",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportSaleInvoiceStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":exportInvoiceId/edit",
                        name: "export-sale-invoice-edit",
                        component: ExportSaleInvoiceEditPage,
                        meta: {
                            title: "Export sales invoices",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportSaleInvoiceStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/export-clients",
        name: "export-client",
        component: ExportClientLayout,
        redirect: { name: "export-client" },
        children: [
            {
                path: "/export-clients",
                component: ExportClientListPage,
                children: [
                    {
                        path: "",
                        name: "export-client-list",
                        component: ExportClientListPage,
                        meta: {
                            title: "Export clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportClientStore/toggleDrawer", false);
                            Store.commit("ExportClientStore/setActiveClient", {});
                            next();
                        },
                    },
                    {
                        path: ":clientId",
                        name: "export-client-view",
                        component: ExportClientListPage,
                        meta: {
                            title: "Export clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportClientStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":clientId/edit",
                        name: "export-client-edit",
                        component: ExportClientListPage,
                        meta: {
                            title: "Export clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExportClientStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/clients",
        name: "client",
        component: ClientLayout,
        redirect: { name: "client" },
        children: [
            {
                path: "/clients",
                component: ClientListPage,
                children: [
                    {
                        path: "",
                        name: "client-list",
                        component: ClientListPage,
                        meta: {
                            title: "Clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ClientStore/toggleDrawer", false);
                            Store.commit("ClientStore/setActiveClient", {});
                            next();
                        },
                    },
                    {
                        path: ":clientId",
                        name: "client-view",
                        component: ClientListPage,
                        meta: {
                            title: "Clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ClientStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":clientId/edit",
                        name: "client-edit",
                        component: ClientListPage,
                        meta: {
                            title: "Clients",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ClientStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/iframe",
        name: "iframe-layout",
        component: IframeLayout,
        redirect: { name: "iframe-layout" },
        children: [
            {
                path: "/iframe",
                component: IframePageView,
                children: [
                    {
                        path: "",
                        name: "iframe-page-view",
                        component: IframePageView,
                        meta: {
                            title: "Iframe page",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            //Store.commit("UserStore/toggleDrawer", false);
                            //Store.commit("UserStore/setActiveUser", {});
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/user-settings",
        name: "user-settings",
        component: UserSettingsLayout,
        redirect: { name: "user-settings" },
        children: [
            {
                path: "/user-settings",
                component: UserSettingsView,
                children: [
                    {
                        path: "",
                        name: "user-settings",
                        component: UserSettingsView,
                        meta: {
                            title: "User settings",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("UserStore/toggleDrawer", false);
                            Store.commit("UserStore/setActiveUser", {});
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/logs",
        name: "logs",
        component: LogsLayout,
        redirect: { name: "logs" },
        children: [
            {
                path: "/logs",
                component: LogsList,
                children: [
                    {
                        path: "",
                        name: "logs",
                        component: LogsList,
                        meta: {
                            title: "Logs",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("UserStore/toggleDrawer", false);
                            Store.commit("LogStore/addCronLogs", []);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/work-order",
        name: "work-orders",
        component: WorkOrderLayout,
        redirect: { name: "work-order-line-number-select" },
        children: [
            {
                path: "line-number-select",
                name: "work-order-line-number-select",
                component: WorkOrderLineNumberSelect,
                meta: {
                    title: "Select line number",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("WorkOrderStore/setSelectedLineNumberType", null);
                    Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", false);
                    next();
                },
            },
            {
                path: "",
                name: "work-order-list",
                component: WorkOrderList,
                meta: {
                    title: "Work Orders",
                    requires_auth: true,
                    breadcrumbs: [
                        { name: "work-order-line-number-select", label: "Select line" },
                        { name: "work-order-list", label: "Work Orders" },
                    ],
                },
                beforeEnter(to, from, next) {
                    let lineNumber = to.query.lineNumber || Store.state.WorkOrderStore.selectedLineNumberType;
                    const searchQuery = to.query.search || Store.state.WorkOrderStore.searchWorkOrderString;

                    Store.commit("WorkOrderStore/setSelectedLineNumberType", lineNumber);
                    Store.commit("WorkOrderStore/setWorkOrderSearch", searchQuery);
                    Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", false);
                    Store.dispatch("SearchHistoryStore/getSearchHistory", to.path.replaceAll("/", ""));

                    if ((!to.query.lineNumber && lineNumber) || (!to.query.search && searchQuery)) {
                        return next({
                            name: to.name,
                            params: to.params,
                            query: { ...to.query, lineNumber, search: searchQuery },
                        });
                    }

                    next();
                },
            },
            {
                path: "group/:workOrderGroupId",
                name: "work-order-view-group",
                component: WorkOrderView,
                meta: {
                    title: "Work order",
                    requires_auth: true,
                    breadcrumbs: [
                        { name: "work-order-line-number-select", label: "Select line" },
                        { name: "work-order-list", label: "Work Orders" },
                        { name: "work-order-view-group", label: "Group" },
                    ],
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", true);
                    next();
                },
            },
            {
                path: ":workOrderId",
                component: WorkOrderView,
                children: [
                    {
                        path: "",
                        name: "work-order-view",
                        component: WorkOrderView,
                        meta: {
                            title: "Work order",
                            requires_auth: true,
                            breadcrumbs: [
                                { name: "work-order-line-number-select", label: "Select line" },
                                { name: "work-order-list", label: "Work Orders" },
                                { name: "work-order-view-group", label: "Group" },
                                { name: "work-order-view", label: "Work Order" },
                            ],
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", false);
                            next();
                        },
                    },
                ],
            },
            {
                path: "group/",
                component: WorkOrderList,
                children: [
                    {
                        path: ":workOrderGroupId/:workOrderId?",
                        name: "work-order-group-view",
                        component: WorkOrderList,
                        meta: {
                            title: "Work Orders",
                            requires_auth: true,
                            breadcrumbs: [
                                { name: "work-order-line-number-select", label: "Select line" },
                                { name: "work-order-list", label: "Work Orders" },
                                { name: "work-order-view-group", label: "Group" },
                            ],
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", true);
                            next();
                        },
                    },
                    {
                        path: ":workOrderGroupId/:workOrderId?/edit",
                        name: "work-order-group-edit",
                        component: WorkOrderList,
                        meta: {
                            title: "",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("WorkOrderStore/toggleWorkOrderGroupDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/notification-center",
        name: "notification-center",
        component: NotificationCenterLayout,
        redirect: { name: "notification-center" },
        children: [
            {
                path: "/notification-center",
                component: NotificationCenterList,
                children: [
                    {
                        path: "",
                        name: "notification-center-list",
                        component: NotificationCenterList,
                        meta: {
                            title: "Notification center",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("NotificationCenterStore/toggleDrawer", false);
                            Store.commit("NotificationCenterStore/resetActiveNotificationData");
                            next();
                        },
                    },
                    {
                        path: ":notificationType/:notificationId",
                        name: "notification-center-view",
                        component: NotificationCenterList,
                        meta: {
                            title: "Notification center",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("NotificationCenterStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/ext-product-price",
        name: "ext-product-prices",
        component: ExtProductPriceLayout,
        children: [
            {
                path: "/ext-product-price",
                component: ExtProductPriceList,
                children: [
                    {
                        path: "",
                        name: "ext-product-price-list",
                        component: ExtProductPriceList,
                        meta: {
                            title: "Price monitoring",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExtProductStore/toggleDrawer", false);
                            Store.commit("ExtProductStore/setActiveExtProductPrice", {});
                            Store.commit("ExtProductStore/setActiveProduct", {});
                            next();
                        },
                    },
                    {
                        path: "/ext-product-price/:extProductPriceId",
                        name: "ext-product-price-view",
                        component: ExtProductPriceView,
                        meta: {
                            title: "Price monitoring",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExtProductStore/toggleDrawer", true);
                            next();
                        },
                    },
                    {
                        path: "/ext-product-price/:extProductPriceId/edit",
                        name: "ext-product-price-edit",
                        component: ExtProductPriceView,
                        meta: {
                            title: "Price monitoring",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ExtProductStore/toggleDrawer", true);
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/campaign",
        name: "campaign",
        component: CampaignLayout,
        children: [
            {
                path: "/campaign",
                component: CampaignList,
                children: [
                    {
                        path: "",
                        name: "campaign-list",
                        component: CampaignList,
                        meta: {
                            title: "Campaigns",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("CampaignStore/toggleDrawer", false);
                            Store.commit("CampaignStore/setActiveCampaign", {});
                            next();
                        },
                    },
                ],
            },

            {
                path: ":campaignId",
                name: "campaign-view",
                component: CampaignList,
                meta: {
                    title: "Campaigns",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("CampaignStore/toggleDrawer", true);
                    next();
                },
            },
            {
                path: ":campaignId/edit",
                name: "campaign-edit",
                component: CampaignList,
                meta: {
                    title: "Campaigns",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("CampaignStore/toggleDrawer", true);
                    next();
                },
            },
        ],
    },
    {
        path: "/production-analysis",
        name: "production-analysis",
        component: ProductionAnalysisLayout,
        redirect: { name: "production-analysis-view" },
        children: [
            {
                path: "/production-analysis-view",
                component: ProductionAnalysisView,
                children: [
                    {
                        path: "",
                        name: "production-analysis-view",
                        component: ProductionAnalysisView,
                        meta: {
                            title: "Production analysis",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/analysis",
        name: "analysis",
        component: AnalysisLayout,
        redirect: { name: "analysis-view" },
        children: [
            {
                path: "/analysis-view",
                component: AnalysisView,
                children: [
                    {
                        path: "",
                        name: "analysis-view",
                        component: AnalysisView,
                        meta: {
                            title: "Analysis",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/shipments",
        name: "shipments",
        component: ShipmentLayout,
        children: [
            {
                path: "/shipments",
                component: ShipmentsList,
                children: [
                    {
                        path: "",
                        name: "shipment-list",
                        component: ShipmentsList,
                        meta: {
                            title: "Shipments",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("ShipmentStore/toggleDrawer", false);
                            Store.commit("ShipmentStore/setActiveShipment", {});
                            next();
                        },
                    },
                ],
            },
            {
                path: ":shipmentId",
                name: "shipment-view",
                component: ShipmentsList,
                meta: {
                    title: "Shipments",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("ShipmentStore/toggleDrawer", true);
                    next();
                },
            },
            {
                path: ":shipmentId/edit",
                name: "shipment-edit",
                component: ShipmentsList,
                meta: {
                    title: "Shipments",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("ShipmentStore/toggleDrawer", true);
                    next();
                },
            },
        ],
    },
    {
        path: "/shipment",
        component: PublicShipmentLayout,
        children: [
            {
                path: ":token",
                name: "public-shipment-view",
                component: PublicShipmentView,
                meta: {
                    title: "Shipment",
                    requires_auth: false,
                },
            },
            {
                path: "/shipment/error",
                name: "error-view",
                component: ErrorView,
                meta: {
                    title: "Shipment",
                    requires_auth: false,
                },
            },
        ],
    },
    {
        path: "/tags",
        name: "tags",
        component: TagLayout,
        children: [
            {
                path: "/tags",
                component: TagListPage,
                children: [
                    {
                        path: "",
                        name: "tag-list",
                        component: TagListPage,
                        meta: {
                            title: "Tags",
                            requires_auth: true,
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("TagStore/toggleDrawer", false);
                            Store.commit("TagStore/setActiveTag", {});
                            next();
                        },
                    },
                ],
            },
            {
                path: ":tagId",
                name: "tag-view",
                component: TagListPage,
                meta: {
                    title: "Tags",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("TagStore/toggleDrawer", true);
                    next();
                },
            },
            {
                path: ":tagId/edit",
                name: "tag-edit",
                component: TagListPage,
                meta: {
                    title: "Tags",
                    requires_auth: true,
                },
                beforeEnter: function (to, from, next) {
                    Store.commit("TagStore/toggleDrawer", true);
                    next();
                },
            },
        ],
    },
];
let router = new VueRouter({
    mode: "history",
    base: "/",
    routes,
});

export default router;

router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.requires_auth)) {
        if (!Store.state.is_logged_in) {
            next({ name: "login" });
        } else {
            let canAccess;
            let routeParts = to.fullPath.split("/");
            routeParts = routeParts[1].split("?");
            let baseRoute = formatBaseRoute(routeParts[0]);
            let itemId = routeParts[2];
            let action = routeParts[3];

            if (to.path === "/user-settings") {
                canAccess = true;
            } else {
                canAccess = await PermissionMixin.methods.canAccessRoute(baseRoute, itemId, action);
            }

            if (["/products", "/products/"].includes(to.path) && !canAccess) {
                for (const route of routes) {
                    const modifiedPath = formatBaseRoute(route.path.replace(/\//g, ""));
                    if (modifiedPath === "user") {
                        continue;
                    }
                    const canAccessModified = await PermissionMixin.methods.canAccessRoute(modifiedPath, null);
                    if (canAccessModified) {
                        next({ path: route.path });
                        return;
                    }
                }
                next({ name: "login" });
            }

            if (canAccess) {
                next();
            } else {
                next({ name: "login" });
            }
        }
    } else {
        next();
    }
});

function formatBaseRoute(br) {
    return br.replace(/s$/, "");
}
